/* eslint-disable import/prefer-default-export */
export const LESSON_HREF =
  '/content/p/freecourses/[goalUID]/[courseTitle]/[courseUID]/[lessonUID]';

export const COURSE_CARD_CLICKED_EVENT =
  'Youtube Courses - Course Card Clicked';
